import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Moment from 'react-moment';
import Barcode from '../comum/Barcode';

function getHistoricoEmissao(mdfe) {
    if (!mdfe) return {};
    return mdfe.ultimoHistoricoEmissaoMDFe || mdfe.ultimoHistoricoEmissaoMdfe || {};
}

function getVeiculos(mdfe) {
    if (!mdfe) return [];
    if (Array.isArray(mdfe.veiculos) && mdfe.veiculos.length > 0) return mdfe.veiculos;
    if (mdfe.veiculo) return [mdfe.veiculo];
    return [];
}

function getCondutores(mdfe) {
    if (!mdfe) return [];
    if (Array.isArray(mdfe.condutores) && mdfe.condutores.length > 0) return mdfe.condutores;
    if (mdfe.motorista && typeof mdfe.motorista === 'object') return [mdfe.motorista];
    return [];
}

function getChaveMdfe(mdfe) {
    if (!mdfe) return '';
    const h = getHistoricoEmissao(mdfe);
    return h.chaveMdfe || mdfe.chaveMdfe || '';
}

export class Damdfe extends Component {

    formatCNPJ(valor) {
        // Remove caracteres não numéricos
        const numeros = valor.replace(/\D/g, '');

        // Aplica a máscara progressivamente
        return numeros
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .substring(0, 18); // Limita ao tamanho máximo do CNPJ formatado
    }

    exibeCabecalho() {
        const mdfe = this.props.damdfe || {};
        const empresa = this.props.damdfe.empresa || this.props.empresaSelecionada || {};
        const endereco = this.props.damdfe.enderecoDto || {};
        const historico = getHistoricoEmissao(mdfe);
        const chaveMdfe = getChaveMdfe(mdfe);
        const qrValue = historico.urlQRCode || mdfe.urlQRCode || chaveMdfe;

        return (
            <div className='damdfe-cabecalho-wrapper'>
                <div className='damdfe-cabecalho-topo'>
                    <div className='damdfe-logo'>
                        {this.props.empresaSelecionada.urlImagem ? (
                            <img src={empresa.urlImagem} alt="" className="damdfe-logo-img" />
                        ) : (
                            <span className='damdfe-logo-texto'>LOGO<br />EMPRESA</span>
                        )}
                    </div>
                    <div className='damdfe-empresa'>
                        <div className='damdfe-empresa-nome'>{empresa.nomeFantasia}</div>
                        {endereco && (
                            <>
                                <div>{endereco.logradouro}{endereco.complemento ? `, ${endereco.complemento}` : ''}</div>
                                <div>{endereco.bairro}, {endereco.cidade && endereco.cidade.nome} - {endereco.cidade && endereco.cidade.uf}</div>
                                <div>CEP: {endereco.cep}</div>
                            </>
                        )}
                        <div>CNPJ: {empresa.cnpj || '-'}</div>
                        <div>IE: {empresa.inscricaoEstadual != null && empresa.inscricaoEstadual !== '' ? empresa.inscricaoEstadual : '-'}</div>
                    </div>
                    <div className='damdfe-titulo-bloco'>
                        <div className='damdfe-titulo-principal'>DAMDFE</div>
                        <div className='damdfe-titulo-subtitulo'>Documento Auxiliar do Manifesto Eletrônico de Documentos Fiscais</div>
                    </div>
                    <div className='damdfe-qrcode'>
                        {qrValue && (
                            <QRCode value={qrValue} style={{ width: 90, height: 90 }} />
                        )}
                    </div>
                </div>

                <div className='damdfe-cabecalho-bottom'>
                    <div className='damdfe-damdfe-label'>
                        <span className='damdfe-label-destaque'>DAMDFE:</span> Documento Auxiliar do Manifesto Eletrônico de Documentos Fiscais
                    </div>
                    <div className='damdfe-campos-topo'>
                        <div className='damdfe-campo-topo'><span>MODELO</span><br />{mdfe.modelo != null ? mdfe.modelo : '58'}</div>
                        <div className='damdfe-campo-topo'><span>SÉRIE</span><br />{mdfe.serie != null ? mdfe.serie : '-'}</div>
                        <div className='damdfe-campo-topo'><span>NÚMERO</span><br />{mdfe.numero != null ? mdfe.numero : '-'}</div>
                        <div className='damdfe-campo-topo'><span>DV</span><br />{mdfe.dv != null ? mdfe.dv : '-'}</div>
                        <div className='damdfe-campo-topo damdfe-campo-topo-largo'>
                            <span>DATA/HORA EMISSÃO</span><br />
                            {mdfe.dataEmissao && <Moment format="DD/MM/YYYY HH:mm">{mdfe.dataEmissao}</Moment>}
                        </div>
                        <div className='damdfe-campo-topo'><span>UF CARREG.</span><br />{mdfe.cidadeOrigem && mdfe.cidadeOrigem.uf}</div>
                        <div className='damdfe-campo-topo damdfe-campo-topo-last'><span>UF DESCARREG.</span><br />{mdfe.cidadeDestino && mdfe.cidadeDestino.uf}</div>
                    </div>
                </div>
            </div>
        )
    }

    exibeBannerContingencia() {
        const mdfe = this.props.damdfe || {};
        if (mdfe.tipoEmissao === '1' || !mdfe.tipoEmissao) return null;

        const tiposContingencia = {
            '2': 'DPEC - Declaração Prévia de Emissão em Contingência',
            '3': 'SCAN - Sistema de Contingência do Ambiente Nacional',
            '7': 'SVC-RS - SEFAZ Virtual de Contingência RS',
            '9': 'DPEC - Declaração Prévia de Emissão em Contingência',
        };
        const descricao = tiposContingencia[mdfe.tipoEmissao] || 'CONTINGÊNCIA';

        return (
            <div className='damdfe-contingencia-banner'>
                <div className='damdfe-contingencia-titulo'>EMITIDO EM CONTINGÊNCIA</div>
                <div className='damdfe-contingencia-tipo'>{descricao}</div>
                {mdfe.dataEntradaContingencia && (
                    <div className='damdfe-contingencia-data'>
                        Entrada em contingência: <Moment format="DD/MM/YYYY HH:mm">{mdfe.dataEntradaContingencia}</Moment>
                    </div>
                )}
                {mdfe.justificativaContingencia && (
                    <div className='damdfe-contingencia-justificativa'>
                        Justificativa: {mdfe.justificativaContingencia}
                    </div>
                )}
            </div>
        )
    }

    exibeCargaRodoviaria() {
        const mdfe = this.props.damdfe || {};
        const pesoOuValor = mdfe.totalPesoCargas != null
            ? mdfe.totalPesoCargas
            : mdfe.totalValorCargas;
        return (
            <div className='damdfe-secao'>
                <div className='damdfe-secao-titulo'>MODELO RODOVIÁRIO DE CARGA</div>
                <div className='damdfe-linha'>
                    <div className='damdfe-campo damdfe-campo-borda'>
                        <span>QTD. CT-e</span>
                        <div>{mdfe.quantidadeCtesVinculados != null ? mdfe.quantidadeCtesVinculados : '-'}</div>
                    </div>
                    <div className='damdfe-campo damdfe-campo-borda'>
                        <span>QTD. NF-e</span>
                        <div>-</div>
                    </div>
                    <div className='damdfe-campo damdfe-campo-borda'>
                        <span>PESO TOTAL (Kg)</span>
                        <div>
                            {pesoOuValor != null
                                ? parseFloat(pesoOuValor).toLocaleString('pt-br')
                                : '-'}
                        </div>
                    </div>
                    <div className='damdfe-campo'>
                        <span>CORMAP N°</span>
                        <div>-</div>
                    </div>
                </div>
            </div>
        )
    }

    exibeBarcode() {
        const chaveMdfe = getChaveMdfe(this.props.damdfe);
        if (!chaveMdfe) return null;
        return (
            <div className='damdfe-barcode'>
                <Barcode value={chaveMdfe} />
            </div>
        )
    }

    exibeAutenticacao() {
        const mdfe = this.props.damdfe || {};
        const historico = getHistoricoEmissao(mdfe);
        const chaveMdfe = getChaveMdfe(mdfe);
        const protocolo = historico.protocolo != null ? historico.protocolo : mdfe.protocolo;

        return (
            <div className='damdfe-secao'>
                <div className='damdfe-linha'>
                    <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex2'>
                        <span>PROTOCOLO DE AUTORIZAÇÃO</span>
                        <div>{protocolo != null ? protocolo : '-'}</div>
                    </div>
                    <div className='damdfe-campo damdfe-campo-flex1'>
                        <span>DATA/HORA</span>
                        <div>{historico.dataHora && <Moment format="DD/MM/YYYY HH:mm">{historico.dataHora}</Moment>}</div>
                    </div>
                </div>
                <div className='damdfe-chave-acesso'>
                    <span>CHAVE DE ACESSO</span>
                    <p>{chaveMdfe}</p>
                </div>
                <div className='damdfe-link-consulta'>
                    Consulte em: https://dfe-portal.svrs.rs.gov.br/MDFe/consulta
                </div>
            </div>
        )
    }

    exibeCondutor() {
        const condutores = getCondutores(this.props.damdfe);
        if (condutores.length === 0) return null;
        return (
            <div className='damdfe-secao'>
                <div className='damdfe-secao-titulo'>CONDUTOR</div>
                {condutores.map((c, i) => (
                    <div key={i} className='damdfe-linha' style={{ borderTop: i > 0 ? '1px solid #000' : 'none' }}>
                        <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex1'>
                            <span>CPF</span>
                            <div>{c.cpf != null && c.cpf !== '' ? c.cpf : '-'}</div>
                        </div>
                        <div className='damdfe-campo damdfe-campo-flex3'>
                            <span>NOME</span>
                            <div>{c.nome || '-'}</div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    exibeVeiculo() {
        const veiculos = getVeiculos(this.props.damdfe);
        if (veiculos.length === 0) return null;
        return (
            <div className='damdfe-secao'>
                <div className='damdfe-secao-titulo'>VEÍCULO</div>
                {veiculos.map((v, i) => (
                    <div key={i} className='damdfe-linha' style={{ borderTop: i > 0 ? '1px solid #000' : 'none' }}>
                        <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex1'>
                            <span>PLACA</span>
                            <div>{v.placa != null ? v.placa : '-'}</div>
                        </div>
                        <div className='damdfe-campo damdfe-campo-flex3'>
                            <span>RENAVAM</span>
                            <div>{v.renavam != null ? v.renavam : '-'}</div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    exibeValePedagio() {
        return (
            <div className='damdfe-secao'>
                <div className='damdfe-secao-titulo'>VALE PEDÁGIO</div>
                <div className='damdfe-linha damdfe-linha-header'>
                    <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex2'><span>RESPONSÁVEL (CNPJ/CPF)</span></div>
                    <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex2'><span>FORNECEDOR (CNPJ)</span></div>
                    <div className='damdfe-campo damdfe-campo-flex2'><span>N° COMPROVANTE</span></div>
                </div>
                <div className='damdfe-linha'>
                    <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex2'><div>&nbsp;</div></div>
                    <div className='damdfe-campo damdfe-campo-borda damdfe-campo-flex2'><div>&nbsp;</div></div>
                    <div className='damdfe-campo damdfe-campo-flex2'><div>{this.props.mdfe ? this.props.mdfe.id : ''}</div></div>
                </div>
            </div>
        )
    }

    exibeObservacoes() {
        const mdfe = this.props.damdfe || {};
        const texto = mdfe.tipoCarga == 'CARGA_GERAL' ? 'Carga Geral': '';
        if (!texto) return null;
        return (
            <div className='damdfe-secao'>
                <div className='damdfe-secao-titulo'>OBSERVAÇÕES</div>
                <div className='damdfe-observacoes'>{texto}</div>
            </div>
        )
    }

    exibeCTesVinculados() {
        const mdfe = this.props.damdfe || {};
        const ctes = mdfe.cteVinculadoDto || mdfe.ctesVinculados;
        if (!ctes || ctes.length === 0) return null;
        return (
            <div className='damdfe-secao'>
                <div className='damdfe-secao-titulo'>CT-es VINCULADOS</div>
                <div className='damdfe-campo'>
                    {ctes.map((cte, i) => {
                        const chave = typeof cte === 'string' ? cte : cte.chaveCte;
                        return <div key={i}>{chave || '-'}</div>;
                    })}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div id="damdfe" className="damdfe-container">
                {this.exibeCabecalho()}
                {this.exibeBannerContingencia()}
                {this.exibeCargaRodoviaria()}
                {this.exibeBarcode()}
                {this.exibeAutenticacao()}
                {this.exibeCondutor()}
                {this.exibeVeiculo()}
                {this.exibeValePedagio()}
                {this.exibeObservacoes()}
                {this.exibeCTesVinculados()}
            </div>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    damdfe: state.damdfe,
});

export default withRouter(connect(mapStateToProps, {})(Damdfe));
